import {
  buildAuthHeaders,
  getCallCenterBaseUrl,
  requestCallCenter,
  unwrapEnvelopeValue,
} from "./CallCenterApi";
import axios from "axios";
import { ORGANIZATION_HEADER } from "../utils/organizationContext";

export const getOrganizationPaymentProofTemplate = async () => {
  const envelope = await requestCallCenter({
    method: "get",
    url: "organization/payment-proof-template",
  });
  return unwrapEnvelopeValue(envelope, "Failed to load payment proof template");
};

export const updateOrganizationPaymentProofTemplate = async (template) => {
  const envelope = await requestCallCenter({
    method: "put",
    url: "organization/payment-proof-template",
    data: { template },
  });
  return unwrapEnvelopeValue(envelope, "Failed to update payment proof template");
};

export const getAdminOrganizationPaymentProofTemplate = async (organizationId) => {
  const envelope = await requestCallCenter({
    method: "get",
    url: `admin/organizations/${organizationId}/payment-proof-template`,
  });
  return unwrapEnvelopeValue(envelope, "Failed to load payment proof template");
};

export const updateAdminOrganizationPaymentProofTemplate = async (organizationId, template) => {
  const envelope = await requestCallCenter({
    method: "put",
    url: `admin/organizations/${organizationId}/payment-proof-template`,
    data: { template },
  });
  return unwrapEnvelopeValue(envelope, "Failed to update payment proof template");
};

export const uploadOrganizationPaymentProofTemplateAsset = async (assetType, file) => {
  const formData = new FormData();
  formData.append("file", file);
  const envelope = await requestCallCenter({
    method: "post",
    url: `organization/payment-proof-template/assets/${assetType}`,
    data: formData,
  });
  return unwrapEnvelopeValue(envelope, `Failed to upload ${assetType}`);
};

export const uploadAdminOrganizationPaymentProofTemplateAsset = async (organizationId, assetType, file) => {
  const formData = new FormData();
  formData.append("file", file);
  const envelope = await requestCallCenter({
    method: "post",
    url: `admin/organizations/${organizationId}/payment-proof-template/assets/${assetType}`,
    data: formData,
  });
  return unwrapEnvelopeValue(envelope, `Failed to upload ${assetType}`);
};

const buildAssetHeaders = (organizationId) => {
  const headers = { ...buildAuthHeaders() };
  if (organizationId != null) {
    headers[ORGANIZATION_HEADER] = String(organizationId);
  }
  return headers;
};

export const fetchPaymentProofTemplateAssetBlob = async (relativePath, organizationId) => {
  const response = await axios.get(`${getCallCenterBaseUrl()}api/${relativePath}`, {
    responseType: "blob",
    headers: buildAssetHeaders(organizationId),
  });
  return response.data;
};

export const blobToDataUrl = (blob) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });

const isApiAssetPath = (value) =>
  typeof value === "string"
  && value.length > 0
  && !value.startsWith("http")
  && !value.startsWith("data:");

export const resolvePaymentProofTemplateImages = async (template, organizationId) => {
  if (!template || typeof template !== "object") {
    return template;
  }

  const next = { ...template };
  const assetKeys = ["logoUrl", "stampImageUrl", "signatureImageUrl"];

  await Promise.all(
    assetKeys.map(async (key) => {
      const value = next[key];
      if (!isApiAssetPath(value)) {
        return;
      }
      const blob = await fetchPaymentProofTemplateAssetBlob(value, organizationId);
      next[key] = await blobToDataUrl(blob);
    })
  );

  return next;
};
